export const SATELLITE = 'Satellite';
export const STREET = 'Street';
export const DARK = 'Dark';
export const LIGHT = 'Light';
export const OUTDOORS = 'Outdoors';
